import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { ThemeProvider } from "styled-components";
import { sendMessage } from "../../api/Slack";
import { steps } from "./StepsPublic";
import "./BunkeyBot.css";

const theme = {
  background: "#ffffff",
  headerBgColor: "#2E97CF",
  headerFontColor: "#ffffff",
  headerFontSize: "15px",
  botBubbleColor: "#f4f4f4",
  botFontColor: "#4A4A4A",
  userBubbleColor: "#ffffff",
  userFontColor: "#4a4a4a"
};

// const COMMERCIALANDSALES = 1
// const SUPPORT = 2
// const POSTVENTA = 3
// const OTHERS = 4

export class BunkeyBotPublic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  handleEndChat = result => {
    sendMessage(JSON.stringify(result));
  };

  render() {
    const { newColor } = this.props;
    const { isOpen } = this.state;

    return (
      <ThemeProvider theme={{ ...theme, headerBgColor: newColor }}>
        <React.Fragment>
          <ChatBot
            className={`bunkey-bot-public`}
            floating={true}
            handleEnd={this.handleEndChat}
            headerTitle="BunkeyBot"
            floatingIcon="/bunkeybot.svg"
            floatingStyle={{
              backgroundColor: "#ffffff",
              border: "1px solid #f0f2f5"
            }}
            placeholder={`¿Te ayudo? Recuerda que soy un robot.`}
            steps={steps}
            opened={isOpen}
            toggleFloating={() => {
              this.setState({
                isOpen: !this.state.isOpen
              });
            }}
          />
          {!isOpen && (
            <div className={`bunkey-bot-div-hover`}>
              Hola, soy BunkeyBot ¿en qué te puedo ayudar?
            </div>
          )}
        </React.Fragment>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = state => {
  return {
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF"
  };
};

export default injectIntl(connect(mapStateToProps)(BunkeyBotPublic));
